import { WatchoServicesCard } from "./WatchoServicesCard/WatchoServicesCard";

export const WatchoServices = ({ setQr, os }) => {
  return (
    <div className="watchoDownloadLPServicesContainer">
      <h6>
        Here’s <span>what you get</span> with vzy
      </h6>
      <div className="watchoServicesWrapper">
        <WatchoServicesCard
          icon="fliqs.png"
          title="Fliqs"
          desc="a curated collection of never before-seen content, award winning films, and original series"
        />
        <WatchoServicesCard
          icon="tvChannels.png"
          title="300+ Live TV Channels"
          desc="to watch whatever you want anywhere, on the go"
        />
        <WatchoServicesCard
          icon="ott.png"
          title="24+ OTT Apps"
          desc="offering Live sports, movies, trending web series, Live TV & More"
        />
        <WatchoServicesCard
          icon="multiLanguage.png"
          title="Multi-language"
          desc="content to suit your preferences"
        />
        <WatchoServicesCard
          icon="multiDevices.png"
          title="Multiple devices"
          desc="stream simultaneously across screens"
        />
        <WatchoServicesCard
          icon="pr.png"
          title="Personalised Recommendations"
          desc="a tailor-made experience just for you!"
        />
      </div>
      <div className="watchoDownloadBtn d-block d-lg-none">
        {os === "iOS" ? (
          <a
            className="btn btn-primary w-100 w-md-auto"
            target="_blank"
            href="https://lets.vzy.one/BshTkVATkTb"
          >
            Experience the vzy App
          </a>
        ) : (
          <a
            className="btn btn-primary w-100 w-md-auto"
            target="_blank"
            href="https://lets.vzy.one/BshTkVATkTb"
          >
            Experience the vzy App
          </a>
        )}
      </div>
      <div className="watchoDownloadBtn text-center d-none d-lg-block">
        <button
          className="btn btn-primary"
          onClick={() => {
            setQr(true);
          }}
        >
          Experience the vzy App
        </button>
      </div>
    </div>
  );
};
